import PropTypes from "prop-types"
import HomeArticleCard from "@/components/cards/HomeArticleCard"

const HomeSection = ({ homePageData }) => {
  const isLiterature = homePageData?.internalTitle.includes("Literature")
  const isCadSymbol = homePageData?.internalTitle.includes("CAD Symbols")
  const isIntelligent = homePageData?.internalTitle.includes(
    "Intelligent Toilets"
  )
  const isBidetSeat = homePageData?.internalTitle.includes("Bidet Seats")
  const isWaterFilterationES = homePageData?.internalTitle.includes(
    "Water Filtration - cards es"
  )
  const isWaterFilterationEN =
    homePageData?.internalTitle.includes("Water Filtration")
  const isFreeStandingBath = homePageData?.internalTitle.includes(
    "Homepage card Landing Page 2"
  )

  return (
    <section
      className={`${
        !isIntelligent &&
        !isBidetSeat &&
        !isWaterFilterationEN &&
        !isWaterFilterationES &&
        !isFreeStandingBath &&
        "bg-[#e3e3e3]"
      }`}
    >
      <div className="w-full max-w-[960px] mx-auto px-7 md:px-4 pt-[20px]">
        {homePageData?.heading && (
          <h1 className="pt-[40px] pb-[20px] leading-[30px] text-[30px] text-[#000] font-[helvitaBold,_Helvetica,_sans-serif]">
            {homePageData?.heading}
          </h1>
        )}
        {homePageData?.cardRows?.map(({ fields, sys }) => (
          <HomeArticleCard
            key={sys?.id}
            cardRows={fields?.cardItem}
            isLiterature={isLiterature || isCadSymbol}
            isCadSymbol={isCadSymbol}
            isIntelligent={isIntelligent}
            isBidetSeat={isBidetSeat}
            isWaterFilterationES={isWaterFilterationES}
            isWaterFilterationEN={isWaterFilterationEN}
            isFreeStandingBath={isFreeStandingBath}
            selectRow={fields?.selectRow}
          />
        ))}
      </div>
    </section>
  )
}

HomeSection.propTypes = {
  homePageData: PropTypes.shape({
    internalTitle: PropTypes.string,
    heading: PropTypes.string,
    cardRows: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          cardItem: PropTypes.array,
        }),
        sys: PropTypes.shape({
          id: PropTypes.string,
        }),
      })
    ),
  }),
}

export default HomeSection
